import { render, staticRenderFns } from "./statrgyManagerForm.vue?vue&type=template&id=a804d860&scoped=true"
import script from "./statrgyManagerForm.vue?vue&type=script&lang=js"
export * from "./statrgyManagerForm.vue?vue&type=script&lang=js"
import style0 from "./statrgyManagerForm.vue?vue&type=style&index=0&id=a804d860&prod&lang=scss&scoped=true"
import style1 from "./statrgyManagerForm.vue?vue&type=style&index=1&id=a804d860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a804d860",
  null
  
)

export default component.exports